document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-card-atc").forEach(form => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      let formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        console.log("✅ Added to cart:", data);

        // Get updated cart state with sections
        return fetch('/cart?sections=cart-drawer,cart-icon-bubble');
      })
      .then(res => res.json())
      .then(state => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents({
            id: Date.now(), // dummy id to satisfy renderContents
            sections: state
          });
        }
      })
      .catch(err => console.error("❌ Error adding to cart:", err));
    });
  });
});
